import { Maximize2 } from 'lucide-react';
import { useChrome } from '../context/ChromeContext';

interface ArcheExpandButtonProps {
  /** Canonical arche id (`arche_*`) whose focus mode this toggles. */
  archeId: string;
  /** Extra classes for the button (sizing/spacing to fit the host toolbar). */
  className?: string;
}

/**
 * The shared "expand to full screen" (focus mode) trigger for arches that render
 * their OWN top bar instead of the platform `ArcheHeader` (multi-ai, chat,
 * social-media, …). It mirrors the `Maximize2` button baked into `ArcheHeader`:
 * clicking it hides the platform Header + suggested-arches sidebar so the arche
 * fills the viewport.
 *
 * Self-hides once the arche is expanded — the way BACK is then the thin
 * `ExpandedArcheHeader` that `ArcheLayout` renders (Back to Fias / Fias AI /
 * Collapse). Keeping the two in one component would double up the toggle; instead
 * this is the "in" and the expanded header is the "out", exactly like
 * `ArcheHeader` (which unmounts wholesale in focus mode).
 */
export function ArcheExpandButton({ archeId, className }: ArcheExpandButtonProps) {
  const { isHeadersHidden, toggleHeaders } = useChrome();
  if (isHeadersHidden(archeId)) return null;

  return (
    <button
      type="button"
      onClick={() => toggleHeaders(archeId)}
      className={`text-muted-foreground transition-colors hover:text-primary ${className ?? ''}`}
      title="Expand to full screen"
      aria-label="Expand to full screen"
    >
      <Maximize2 className="h-5 w-5" />
    </button>
  );
}

export default ArcheExpandButton;
